import { FC } from "react";
import { useRouter } from "next/router";
import { CircularProgress } from "@mui/material";
import { PriceDetailsGrid } from "../../molecules/PriceDetailsGrid";
import { FiArrowRightCircle } from "react-icons/fi";
import { useLocaleContext } from "../../context/LocaleContext/LocaleContext";
import { useGetCartQuery } from "../../../store";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { CartProductEntity } from "../../../types/cart_response_type";
import { CartItem } from "./CartItem";
import { NoItemsFound } from "../../atoms";
import { AuthLayout } from "../../layouts";
import withAuth from "../../hoc/withAuth";

export const CheckoutCart: FC = withAuth<{}>(() => {
  const router = useRouter();
  const isLoggedin = useTypedSelector(state => state.auth.isLoggedin);
  const { data, isLoading } = useGetCartQuery(undefined, { skip: !isLoggedin });
  const { currency } = useLocaleContext();

  const activePrice = data?.value.find(p => p.code === currency);
  const currencySymbol = activePrice?.code === "INR" ? "₹" : "$";

  const isButtonDisabled = () => {
    const products = data!.products.filter(
      p => !p.hasOwnProperty("errMessage")
    ) as CartProductEntity[];
    const proceedButtonDisabled = products?.every(p => p.isAvailable);
    return Boolean(proceedButtonDisabled);
  };

  return (
    <AuthLayout title="Cart">
      {isLoading && !data && (
        <div className="flex-1 flex items-center justify-center">
          <CircularProgress size="small" />
        </div>
      )}
      {data && (
        <>
          {data.products.length > 0 ? (
            <div className="flex flex-col lg:grid lg:grid-cols-12 gap-14">
              <div className="col-span-12 lg:col-span-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-8">
                {data?.products
                  .filter(p => p.cartItemType === "valid")
                  .map((p: any) => {
                    return <CartItem key={p.id} product={p} />;
                  })}
              </div>
              <div className="col-span-12 lg:col-span-4">
                {activePrice && (
                  <PriceDetailsGrid
                    data={[
                      {
                        label: "mrp",
                        value: `${currencySymbol} ${activePrice.mrp}`,
                      },
                      {
                        label: "discount",
                        value: `${activePrice.discount}%`,
                      },
                      {
                        label: "sellingPrice",
                        value: `${currencySymbol} ${activePrice.sellingPrice}`,
                      },
                    ]}
                    submitButtonProps={{
                      label: "Proceed With Address",
                      onSubmit: () =>
                        router.push(
                          `/checkout/address?store-pickup-available=${false}`
                        ),
                      // router.push(
                      //   `/checkout/address?store-pickup-available=${data.products.every(
                      //     (p: any) => p.variants[0].shippingProfile?.id === 2
                      //   )}`
                      // )
                      icon: <FiArrowRightCircle />,
                      disabled: !isButtonDisabled(),
                    }}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className="mt-12">
              <NoItemsFound
                title="Oops! Your cart is empty"
                message="looks like you haven't added anything to your cart yet."
                icon={null}
              />
            </div>
          )}
        </>
      )}
    </AuthLayout>
  );
});
